import defaultFilters from './defaultFilters'
export default {
  snackMessage: {},
  filters: defaultFilters,
  filterRowShown: false,
  headerHeight: 0,
  filledSteps: {
    stepA: false,
    stepB: false,
    stepC: false
  },
  initCount: 0
}
